import { CodeIcon, CopyIcon } from "@radix-ui/react-icons";
import Notifications from "util/notifications";

const LINK_BUTTON =
  "flex items-center gap-1 rounded-md border border-green-600 px-2 py-1 text-xs font-semibold text-green-700 hover:bg-green-50";

/**
 * A public page's link with Copy and Open, and Embed when the page can go on
 * a website: Embed copies the code to paste there (`embed` makes it). For
 * something that isn't a page, like an email address, `open={false}` leaves
 * out Open and `copied` says what was copied.
 */
export default function CopyLinkRow({
  url,
  embed,
  open = true,
  copied = "Link copied",
}: {
  url: string;
  embed?: () => string;
  open?: boolean;
  copied?: string;
}) {
  return (
    <div className="mt-1 flex items-center gap-2 rounded-md border border-gray-200 bg-gray-50 py-1.5 pl-3 pr-1.5 text-sm">
      <span className="min-w-0 flex-1 truncate" title={url}>
        {url.replace(/^https?:\/\//, "")}
      </span>
      <button
        type="button"
        className={LINK_BUTTON}
        onClick={() => {
          navigator.clipboard.writeText(url);
          Notifications.success(copied);
        }}
      >
        <CopyIcon /> Copy
      </button>
      {embed && (
        <button
          type="button"
          className={LINK_BUTTON}
          title="Copy the code that puts this page on your website"
          onClick={() =>
            navigator.clipboard
              .writeText(embed())
              .then(() =>
                Notifications.success(
                  "Code copied. Paste it into your website."
                )
              )
              .catch(() => Notifications.error("Could not copy. Try again."))
          }
        >
          <CodeIcon /> Embed
        </button>
      )}
      {open && (
        <a href={url} target="_blank" rel="noreferrer" className={LINK_BUTTON}>
          Open
        </a>
      )}
    </div>
  );
}
